export var LOGIN = '/accounts/login/';
export var LOGOUT = '/accounts/logout/';
export var PROFILE = '/accounts/profile/';
export var VERSION = '/api/version/';
//# sourceMappingURL=paths.js.map